import React from 'react';
import { connect } from 'react-redux';
import { getPowers, submitPowers, updatePackages } from '../../../actionCreators/success';
import { getLensPackages } from '../../../actionCreators/product';
import { Form, Field } from 'react-final-form';
import { getNumericChars } from '../../../utils/helper';
import { Modal } from 'react-bootstrap';

const sameValueFields = ['lensWidth', 'lensHeight'];

function setNumberToInput(e, input) {
    const val = getNumericChars(e.target.value);
    input.onChange(val);
}

class UpdatePower extends React.PureComponent {
    constructor(props) {
        super(props);
        this.mutators = {
            onChangeSelect: (args, state, utils) => {
                utils.changeValue(state, args[0], () => args[1]);
            }
        };
        const leftPresc = this.getValuesFromPrescriptionObj('left', props.item.prescription);
        const rightPresc = this.getValuesFromPrescriptionObj('right', props.item.prescription);
        this.initialValues = { ...leftPresc, ...rightPresc };
        this.pristine = { ...this.initialValues };
        this.changedPristine = {};
        this.state = { showConfirmationModal: false, dirtyObj: {} };
        this.submit = this.submit.bind(this);
        this.hideModal = this.hideModal.bind(this);
        this.updatePower = this.updatePower.bind(this);
    }
    componentDidMount() {
        const { item, getPowers, getLensPackages } = this.props;
        const { productId, prescription } = item || {};
        if (productId && prescription) {
            const powerType = prescription.powerType && prescription.powerType.toLowerCase();
            getPowers(productId, powerType);
            getLensPackages(productId, powerType, item.frameType);
        }
    }
    componentDidUpdate(prevProps) {
        const { powersDetail, powerSubmitted } = this.props;
        if (prevProps.powersDetail !== powersDetail && powersDetail && powersDetail.powerTypeList) {
            this.labels = powersDetail.powerTypeList.reduce((m, opt) => {
                m[opt.type] = opt.label;
                return m;
            }, {});
        }
        if (powerSubmitted !== prevProps.powerSubmitted && powerSubmitted) {
            this.setState({ showConfirmationModal: false });
            this.pristine = { ...this.pristine, ...this.changedPristine };
            this.changedPristine = {};
        }
    }
    onSelectChange(e, input, type, field) {
        const val = e.target.value;
        if (sameValueFields.includes(type)) {
            this.formMutators.onChangeSelect(field, val);
        }
        input.onChange(val);
    }
    getValuesFromPrescriptionObj(type, prescObj) {
        if (prescObj && prescObj[type]) {
            return Object.keys(prescObj[type]).reduce((m, key) => {
                m[`${key}-${type}`] = prescObj[type][key];
                return m;
            }, {});
        }
        return {};
    }
    getLenskartPrice(prices) {
        const lenskartPrice = prices.filter(p => p.name === 'Lenskart Price');
        return <span className="inline-block margin-l5">&#8377;{lenskartPrice ? lenskartPrice[0].price : null}</span>;
    }
    getDirtyValues(values) {
        const dirtyObj = {};
        Object.keys(values).forEach(key => {
            if (values[key] !== this.pristine[key]) {
                dirtyObj[key] = values[key];
            }
        });
        return dirtyObj;
    }
    hideModal() {
        this.setState({ showConfirmationModal: false });
    }
    submit(values) {
        const dirtyObj = this.getDirtyValues(values);
        this.setState({ showConfirmationModal: true, dirtyObj });
    }
    updatePower(values) {
        const { item, email, userName, submitPower, updatePackage, orderId } = this.props;
        const { dirtyObj } = this.state;
        const updatedPresc = { left: {}, right: {} };
        Object.keys(values).forEach(presc => {
            if (values[presc]) {
                this.changedPristine[presc] = dirtyObj[presc];
                const arr = presc.split('-');
                if (updatedPresc[arr[1]]) updatedPresc[arr[1]][arr[0]] = dirtyObj[presc];
            }
        }, {});
        const prescription = { ...item.prescription };
        prescription.left = { ...prescription.left, ...updatedPresc.left };
        prescription.right = { ...prescription.right, ...updatedPresc.right };
        if (!prescription.userName) prescription.userName = userName;
        const powerType = prescription.powerType && prescription.powerType.toLowerCase();
        const lensPackage = {
            productId: item.productId,
            powerType,
            packageId: this.packageId
        };
        const OdrId = orderId;
        submitPower(item.id, prescription, email, OdrId);
        updatePackage(item.id, lensPackage, OdrId);
    }
    render() {
        const { powersDetail, item, submitPowerLoader, powerSubmitted, lensPackages } = this.props;
        const { showConfirmationModal, dirtyObj } = this.state;
        const currentPackage = item.options && item.options[0] && item.options[0].name;
        return (
            <React.Fragment>
                <Form
                    onSubmit={this.submit}
                    mutators={this.mutators}
                    initialValues={this.initialValues}
                    render={({ handleSubmit, form }) => {
                        this.formMutators = form.mutators;
                        return (<form onSubmit={handleSubmit} noValidate name={`eye-power-${item.id}`} style={{ fontSize: '13px' }}>
                            {powersDetail && powersDetail.powerTypeList.map(eyeField => {
                                const options = eyeField.powerDataList && eyeField.powerDataList[0] && eyeField.powerDataList[0].value || [];
                                return (
                                    <React.Fragment key={eyeField.label}>
                                        {eyeField.inputType === 'drop_down' && <div className="form-group-container">
                                            <div className="form-group">
                                                <label className="padding-r10">Right {eyeField.label}</label>
                                                <Field name={`${eyeField.type}-right`} >
                                                    {({ input }) => {
                                                        return (
                                                            <select {...input} className="form-control" onChange={e => this.onSelectChange(e, input, eyeField.type, `${eyeField.type}-left`)}>
                                                                <option value="">--Please Select--</option>
                                                                {options.map(opt => <option key={opt} value={opt}>{opt}</option>)}
                                                            </select>
                                                        );
                                                    }}
                                                </Field>
                                            </div>
                                            <div className="form-group">
                                                <label className="padding-r10">Left {eyeField.label}</label>
                                                <Field name={`${eyeField.type}-left`} >
                                                    {({ input }) => {
                                                        return (
                                                            <select {...input} className="form-control" onChange={e => this.onSelectChange(e, input, eyeField.type, `${eyeField.type}-right`)}>
                                                                <option value="">--Please Select--</option>
                                                                {options.map(opt => <option key={opt} value={opt}>{opt}</option>)}
                                                            </select>
                                                        );
                                                    }}
                                                </Field>
                                            </div>
                                        </div>}
                                        {eyeField.inputType === 'field' && <div className="form-group-container">
                                            <div className="form-group">
                                                <label className="padding-r10">Right {eyeField.label}</label>
                                                <Field name={`${eyeField.type}-right`} >
                                                    {({ input }) => (
                                                        <React.Fragment>
                                                            <input {...input} type="tel" onChange={e => setNumberToInput(e, input)} autoComplete="off" maxLength="3" className="form-control eyeField-power" />
                                                        </React.Fragment>
                                                    )}
                                                </Field>
                                            </div>
                                            <div className="form-group">
                                                <label className="padding-r10">Left {eyeField.label}</label>
                                                <Field name={`${eyeField.type}-left`} >
                                                    {({ input }) => (
                                                        <React.Fragment>
                                                            <input {...input} type="tel" onChange={e => setNumberToInput(e, input)} autoComplete="off" maxLength="3" className="form-control eyeField-power" />
                                                        </React.Fragment>
                                                    )}
                                                </Field>
                                            </div>
                                        </div>}
                                    </React.Fragment>
                                );
                            })}
                            <div className="form-group pkg-heading">Current Package: {currentPackage}</div>
                            {lensPackages && lensPackages.map(pkg => (
                                <div className="form-group" key={pkg.id}>
                                    <label>
                                        <Field name="package" component="input" type="radio" value={pkg.name} onClick={() => { this.packageId = pkg.id; }} />
                                        <span className="inline-block margin-l5">{pkg.name}({this.getLenskartPrice(pkg.prices)})</span>
                                    </label>
                                </div>
                            ))}
                            {!submitPowerLoader && powerSubmitted && <div className="margin-t10 margin-b10" style={{ color: '#cc0000' }}>Power Updated</div>}
                            <div className="submit-button">
                                <button className="form-SLA_field-row_submit bora-2 fs16 fw700" type="submit" style={{ width: '200px' }}>Submit</button>
                            </div>
                        </form>);
                    }}
                />
                <Modal backdrop="static" show={showConfirmationModal} onHide={this.hideModal}>
                    <Modal.Body>
                        {Object.keys(dirtyObj).length ? (
                            <Form
                                onSubmit={this.updatePower}
                            >
                                {({ handleSubmit }) => {
                                    return (
                                        <form className="update-power-modal" onSubmit={handleSubmit}>
                                            <div className="update-power-header">All Modified Power Options in Edit Power Category</div>
                                            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)' }}>
                                                <div className="fs15 padding-b3">Power Option</div>
                                                <div className="fs15">Modified Value</div>
                                                <div className="fs15 text-center">Check to Confirm</div>
                                                {Object.keys(dirtyObj).map(key => {
                                                    const arr = key.split('-');
                                                    return (<React.Fragment key={key}>
                                                        <div className="text-capitalize fs13">{arr.length === 1 ? arr[0] : arr[1]} {this.labels[arr[0]]}</div>
                                                        <div className="fs13 padding-t3 padding-b3">{dirtyObj[key]}</div>
                                                        <div className="text-center"><Field name={key} component="input" type="checkbox"></Field></div>
                                                    </React.Fragment>);
                                                })}
                                            </div>
                                            <div className="modal-btns margin-t25">
                                                <button type="submit" className="form-SLA_field-row_submit bora-2 fw700">
                                                    {submitPowerLoader ? <div className="spinner-border text-light" role="status">
                                                        <span className="sr-only">Loading...</span>
                                                    </div> : <span>Submit</span>}
                                                </button>
                                                <button type="button" onClick={this.hideModal} className="form-SLA_field-row_submit cancel bora-2 fw700">Cancel</button>
                                            </div>
                                        </form>
                                    );
                                }}
                            </Form>
                        ) : (<div className="update-power-modal">
                            <div className="fs16 margin-b15 text-center">Opps!! You haven't changed anything.</div>
                            <div className="modal-btns">
                                <button type="button" onClick={this.hideModal} className="form-SLA_field-row_submit">Ok</button>
                            </div>
                        </div>)}
                    </Modal.Body>
                </Modal>
            </React.Fragment>
        );
    }
}

function mapStateToProps(state) {
    const powersDetail = state.success.powersDetail && state.success.powersDetail.result;
    const lensPackages = state.product.getLensPackages && state.product.getLensPackages.result ? state.product.getLensPackages.result.packages : null;
    return {
        powersDetail,
        lensPackages,
        submitPowerLoader: state.success.loading,
        powerSubmitted: state.success.powerSubmitted
    };
}

function mapDispatchToProps(dispatch) {
    return {
        getPowers: (productId, powerType) => dispatch(getPowers(productId, powerType)),
        submitPower: (id, prescription, email, OdrId) => dispatch(submitPowers(id, prescription, email, OdrId)),
        getLensPackages: (productId, powerType, frameType) => dispatch(getLensPackages(productId, powerType, frameType, false, '')),
        updatePackage: (id, lensPackage, OdrId) => dispatch(updatePackages(id, lensPackage, OdrId))
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(UpdatePower);
